module.exports = __webpack_public_path__ + "img/success-icon.f14467e7.svg";